import BaseHttpService from '../BaseHttpService';
import { IAutomotiveWorkOrderQuoteRequest, IAutomotiveWorkOrderQuoteSummary } from 'JS/types/automotive/WorkOrderQuote';
import { IBaseHttpService } from 'JS/types/Http';

export interface IInstallationQuoteService {
	getQuote(request: IAutomotiveWorkOrderQuoteRequest): Promise<IAutomotiveWorkOrderQuoteSummary>;
}

export class InstallationQuoteService implements IInstallationQuoteService {
	constructor(private _httpService: IBaseHttpService = new BaseHttpService) {}

	getQuote(request: IAutomotiveWorkOrderQuoteRequest): Promise<IAutomotiveWorkOrderQuoteSummary> {
		return this._httpService.post<IAutomotiveWorkOrderQuoteSummary>('/automotive-scheduler/installation-quote', request);
	}
}